import { mutatorAction } from "satcheljs";
import { UserStore } from "sh-stores";

export default mutatorAction('SET_DISABLE_OPENSHIFT_TOGGLE', function setDisableHideOpenShiftRowsToggle(disableHideOpenShiftRowsToggle: boolean) {
    UserStore().disableHideOpenShiftRowsToggle = disableHideOpenShiftRowsToggle;
});
